<template>
  <div     >
	  
		
		<div  :class="{'mobile' : !isPc}"  class="publicFooter">
			 <div class="row">
				 <img class="_logo" :src="require('@/index/footer@2x.png')" />
			 </div>
			 
			 <div  class="row font1">
				 © QingCloud Technologies 2021
			 </div>
			 
			 <div  style="    align-items: center;"  class="row font2">
			 	京ICP备13019086号 <img class="ghs" src="@/ghs.png" />京公网安备11010502030190
			 </div>
		</div>
		
		
  </div>
</template>

<script>
import {os} from "../../utils";


export default {
  name: 'publicFooter',
  props: {
    msg: String
  },
  data(){
	  return{
		isPc : os.isPc
	  }
  },
  beforeCreate(){ 
	 
  },
  created(){
	//this.isPc = os.isPc; 
  }
}
</script>
<style lang="scss" scoped>
	.publicFooter{
		height: 1.08rem;
		background: #333333;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		._logo{
			height: 0.25rem;
		}
		
		.font1{
			font-size: 0.08rem;
			color: #5b5b5b;    
			margin-top: 0.1rem;
			margin-bottom: 0.05rem;
		}
		
		.font2{
			font-size: 0.08rem;color: #5b5b5b;
		}
		
		.ghs{
			width: 0.11rem;
			height: 0.11rem;
			    margin-left: 0.1rem;
			    margin-right: 0.05rem;
		}
	}
	
	.publicFooter.mobile{
		height: 3.33rem;
		._logo{
			width: 4.64rem;
			height: 0.72rem;
		}
		.font1{
			margin-top: 0.3rem;
			margin-bottom: 0.1rem;
			margin-bottom: 0.05rem;
		}
		
		.font2{
			font-size: 0.24rem;
		}
		
		.ghs{
			width: 0.32rem;
			height: 0.32rem;
		}
	}
	
</style>
